import SideBar from "../../components/SideBar/SideBar";
import MobileTopBar from "../../components/SideBar/MobileTopBar";
import { Outlet, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useAppSelector } from "../../store";
import { canAccessPath, firstAllowedPath } from "../../config/admin-permissions";

function Home() {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useAppSelector((state) => state.auth);
    // Cho phép admin và mod (CTV). Vai trò khác bị đẩy về login.
    const role = auth.userInfo?.role;
    if (auth.isLogined && role !== "admin" && role !== "mod") {
        localStorage.removeItem("access_token");
        navigate("/login");
    }
    // Guard route cho mod: gõ URL mục bị cấm -> đẩy về mục được phép đầu tiên.
    if (role === "mod" && !canAccessPath(auth.userInfo, location.pathname)) {
        return <Navigate to={firstAllowedPath(auth.userInfo)} replace />;
    }
    return (
        <div className="h-dvh flex flex-col lg:flex-row">
            {/* Mobile-only top bar with hamburger -> Drawer nav */}
            <MobileTopBar />
            {/* Desktop-only fixed sidebar */}
            <SideBar />
            {/* min-w-0 lets wide tables scroll inside the page instead of
                stretching the whole layout off-screen on small viewports. */}
            <main className="flex-1 min-w-0 flex flex-col overflow-auto">
                <Outlet />
            </main>
        </div>
    );
}

export default Home;
